import { CosmeticStatus } from 'src/utils/types';
import { ButtonGroupStatus, InventoryButtonStatus, SaleButtonStatus } from './types';
export const getButtonGroupStatus = ({
  cosmeticDetail,
  currentUser
}) => {
  var _cosmeticDetail$userA;

  const {
    status
  } = cosmeticDetail.cosmeticInfo;
  const isItemOwnedByUser = currentUser && ((_cosmeticDetail$userA = cosmeticDetail.userAddress) === null || _cosmeticDetail$userA === void 0 ? void 0 : _cosmeticDetail$userA.toLocaleUpperCase()) === currentUser.address.toLocaleUpperCase();

  if (isItemOwnedByUser) {
    return ButtonGroupStatus.INVENTORY;
  }

  if (status === CosmeticStatus.SELLING) {
    return ButtonGroupStatus.SALE;
  }

  return ButtonGroupStatus.GUEST;
};
export const getSaleButtonStatus = cosmeticDetail => {
  const {
    status
  } = cosmeticDetail.cosmeticInfo;

  if (status === CosmeticStatus.SELLING) {
    return SaleButtonStatus.IS_AVAILABLE;
  }

  return undefined;
};
export const getInventoryButtonStatus = cosmeticDetail => {
  const {
    cosmeticInfo: {
      status
    }
  } = cosmeticDetail;

  if (status === CosmeticStatus.USER_NOT_MINT) {
    return InventoryButtonStatus.IS_NOT_MINT;
  }

  if (status === CosmeticStatus.AVAILABLE) {
    return InventoryButtonStatus.IS_AVAILABLE;
  }

  if (status === CosmeticStatus.SELLING) {
    return InventoryButtonStatus.IS_SELLING;
  }

  return undefined;
};